<div class="excel-upload-container">
  <!-- Hidden file input -->
  <input
    #fileInput
    type="file"
    class="d-none"
    [accept]="acceptedTypes"
    [multiple]="allowMultiple"
    [disabled]="disabled"
    (change)="onFileInputChange($event)">

  <!-- Main upload area -->
  <div 
    class="upload-area"
    [class.drag-over]="isDragOver"
    [class.disabled]="disabled"
    [class.uploading]="isUploading"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="openFileDialog()">
    
    <!-- Upload icon and content -->
    <div class="upload-content text-center">
      <div class="upload-icon mb-3">
        <i class="fas fa-file-excel fa-3x" [class.text-success]="uploadResult" [class.text-muted]="!uploadResult && !isUploading" [class.text-primary]="isUploading"></i>
      </div>
      
      <!-- Default state -->
      <div *ngIf="!isUploading && !uploadResult && !error" class="upload-text">
        <h5 class="mb-2">Drop Excel file here</h5>
        <p class="text-muted mb-2">or click to browse</p>
        <small class="text-muted">
          Supported formats: {{ acceptedTypes }}
          <br>
          Maximum size: {{ (maxFileSize / (1024 * 1024)).toFixed(0) }}MB
        </small>
      </div>

      <!-- Upload in progress -->
      <div *ngIf="isUploading" class="upload-progress">
        <h5 class="mb-3">{{ progress.message }}</h5>
        
        <!-- Progress bar -->
        <div class="progress mb-3" style="height: 8px;">
          <div 
            class="progress-bar progress-bar-striped progress-bar-animated"
            [class]="getProgressBarClass()"
            [style.width.%]="progress.percentage"
            role="progressbar">
          </div>
        </div>
        
        <!-- Progress details -->
        <div class="progress-details">
          <small class="text-muted">
            {{ progress.percentage.toFixed(0) }}% - {{ progress.stage | titlecase }}
          </small>
        </div>
      </div>

      <!-- Upload complete -->
      <div *ngIf="uploadResult && !isUploading" class="upload-success">
        <h5 class="text-success mb-2">
          <i class="fas fa-check-circle me-2"></i>
          Upload Complete
        </h5>
        <div class="file-details">
          <p class="mb-1"><strong>{{ uploadResult.filename }}</strong></p>
          <small class="text-muted">
            {{ formatNumber(uploadResult.rowCount) }} rows, 
            {{ uploadResult.headers.length }} columns
            <br>
            Size: {{ getFileSize() }}
          </small>
        </div>
        
        <!-- Reset button -->
        <button 
          type="button" 
          class="btn btn-outline-primary btn-sm mt-2"
          (click)="resetUpload()">
          <i class="fas fa-upload me-1"></i>
          Upload Another File
        </button>
      </div>

      <!-- Error state -->
      <div *ngIf="error" class="upload-error">
        <h5 class="text-danger mb-2">
          <i class="fas fa-exclamation-circle me-2"></i>
          Upload Failed
        </h5>
        <p class="text-danger mb-2">{{ error }}</p>
        
        <!-- Retry button -->
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm"
          (click)="resetUpload()">
          <i class="fas fa-redo me-1"></i>
          Try Again
        </button>
      </div>
    </div>
  </div>

  <!-- File preview section -->
  <div *ngIf="uploadResult" class="file-preview mt-4">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h6 class="mb-0">
          <i class="fas fa-table me-2"></i>
          Data Preview
        </h6>
        <span class="badge bg-primary">{{ formatNumber(uploadResult.rowCount) }} rows</span>
      </div>
      <div class="card-body p-0">
        <!-- Headers -->
        <div class="table-responsive">
          <table class="table table-sm table-bordered mb-0">
            <thead class="table-light">
              <tr>
                <th class="text-center" style="width: 50px;">#</th>
                <th *ngFor="let header of uploadResult.headers; let i = index">
                  {{ header || 'Column ' + (i + 1) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- Show first 5 rows -->
              <tr *ngFor="let row of uploadResult.data.slice(0, 5); let rowIndex = index">
                <td class="text-center text-muted">{{ rowIndex + 1 }}</td>
                <td *ngFor="let cell of row; let cellIndex = index">
                  <span class="text-truncate d-inline-block" style="max-width: 150px;" [title]="cell">
                    {{ cell || '-' }}
                  </span>
                </td>
              </tr>
              
              <!-- Show more indicator -->
              <tr *ngIf="uploadResult.rowCount > 5">
                <td colspan="100" class="text-center text-muted py-3">
                  <i class="fas fa-ellipsis-h me-2"></i>
                  {{ formatNumber(uploadResult.rowCount - 5) }} more rows available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>